module.exports = __webpack_public_path__ + "assets/img/jtfx41.fc4e4a52.jpg";